<template>
  
    <div class="mt-20" :key="objectsBag.isOpenMenu">

        <!-- <slide :closeOnNavigation="true" :isOpen="menuOpen">
            
            <div class=" h-screen flex flex-col content-around">
                <div class="my-btn my-btn-pink">

                    <router-link to="/home" class=" my-router-link">
                    <label class="myMenuTextColor">{{ this.$t('menu.home')}}</label></router-link>
                </div>

                <div class="my-btn my-btn-pink mt-4">

                    <router-link to="/sessions" class="my-router-link">
                    <label class="myMenuTextColor">{{ this.$t('menu.sessions')}}</label></router-link>

                </div>
            </div>
        </slide> -->
        
        <!-- <div class="rounded border border-black"> -->
         <div class="">
          <sidebar-menu :menu="menu" :rtl="isArabic" :hideToggle="false" :disableHover="true" 
          @toggle-collapse="onToggleCollapse" @item-click="onItemClick" :collapsed="!menuOpen">
                          
            <div slot="toggle-icon" class=" w-full h-full flex justify-center items-center bg-white">

                <div  v-if="$i18n.locale != 'ar'" class="rounded-full w-5/6 h-5/6 border-2 border-pink-600">

                    <div v-if="!objectsBag.isOpenMenu">

                        <font-awesome-icon icon="sign-in-alt" size="lg"/>
                    </div>

                        <div v-else>

                        <font-awesome-icon class="fa-rotate-180" icon="sign-in-alt" size="lg"/>
                    </div>                    
                </div>

                <div  v-else class="rounded-full w-5/6 h-5/6 border-2 border-pink-600">

                    <div v-if="!objectsBag.isOpenMenu">

                        <font-awesome-icon class="fa-rotate-180" icon="sign-in-alt" size="lg"/>
                    </div>

                        <div v-else>

                        <font-awesome-icon icon="sign-in-alt" size="lg"/>
                    </div>                 
                </div>
                <!-- <img class="w-12 h-12 rounded" src="@/assets/images/only-logo.jpg"/> -->
            </div>
          </sidebar-menu>
        </div>          

    </div>
</template>

<script>

// import { Slide } from 'vue-burger-menu'  // import the CSS transitions you wish to use, in this case we are using `Slide`

// import { SidebarMenu } from 'vue-sidebar-menu'


// import '@/src/assets/css/menu-scss/vue-sidebar-menu.scss'
// import './assets/css/menu-scss/vue-sidebar-menu.scss'

import { SidebarMenu } from 'vue-sidebar-menu/src/index'



export default {

    mounted(){

        this.setMenu();
        // console.log(`this.objectsBag: ${JSON.stringify(this.objectsBag)}`);
    },

    components: {
        // Slide,
        SidebarMenu
         // Register your component
    },

    props:{

        isOpenMenu: false,
        // isOpen: true,
        objectsBag:{

            type: Object
        },
        points: 0,
    },

    computed:{

        valueChanged(){

            // console.log(`in valueChanged with: ${this.objectsBag.isOpenMenu}`);
            return this.objectsBag.isOpenMenu;
        },
    },
    
    methods:{

        setMenu(){

            this.menu = [
                    {
                        header: true,
                        title: `${this.$t('profile.youHave')} ${this.points} ${this.$t('profile.points2')}`,
                        hiddenOnCollapse: true
                    },
                    {
                        href: '/',
                        title: this.$t('menu.home'),
                        // icon: '/assets/images/only-logo.jpg'
                        // icon: 'user-secret'
                        icon: {
                            element: 'font-awesome-icon',
                            attributes: {
                            icon: 'home' // Or whatever icon you want
                            }
                        }
                    },
                    {
                        href: '/profile',
                        title: this.$t('menu.profile'),
                        // icon: '/assets/images/only-logo.jpg'
                        // icon: 'user-secret'
                        icon: {
                            element: 'font-awesome-icon',
                            attributes: {
                            icon: 'address-book' // Or whatever icon you want
                            }
                        }
                    },

                    // {
                    //     href: '/bookings',
                    //     title: this.$t('menu.tickets'),
                    //     // icon: '/assets/images/only-logo.jpg'
                    //     // icon: 'user-secret'
                    //     icon: {
                    //         element: 'font-awesome-icon',
                    //         attributes: {
                    //         icon: 'clipboard-list' // Or whatever icon you want
                    //         }
                    //     }
                    // },

                    {
                        href: '/activities',
                        title: this.$t('menu.inbox'),
                        // icon: '/assets/images/only-logo.jpg'
                        // icon: 'user-secret'
                        icon: {
                            element: 'font-awesome-icon',
                            attributes: {
                            icon: 'envelope' // Or whatever icon you want
                            }
                        }
                    },

                    {
                        href: '/packages',
                        title: this.$t('menu.myPackages'),
                        // icon: '/assets/images/only-logo.jpg'
                        // icon: 'user-secret'
                        icon: {
                            element: 'font-awesome-icon',
                            attributes: {
                            // icon: 'money-check-alt' // Or whatever icon you want
                            icon: 'coins' // Or whatever icon you want

                            }
                        }
                    },


                    {
                        href: '',
                        title: this.$t('menu.sport'),
                        icon: {
                            element: 'font-awesome-icon',
                            attributes: {
                            icon: 'futbol' 


                            }
                        },

                        child: [
                            {
                                href: '/player',
                                title: this.$t('menu.playerProfile'),
                                icon: {
                                    element: 'font-awesome-icon',
                                    attributes: {
                                    icon: 'running',


                                    }
                                },
                            },
                            {
                                href: '/playersgroups',
                                title: this.$t('menu.allPlayersGroups'),
                                icon: {
                                    element: 'font-awesome-icon',
                                    attributes: {
                                    icon: 'users',
                                    }
                                },
                            },
                        ]
                    },

                    {
                        href: '/privacyPolicy',
                        title: this.$t('menu.privacyPolicy'),
                        // icon: '/assets/images/only-logo.jpg'
                        // icon: 'user-secret'
                        icon: {
                            element: 'font-awesome-icon',
                            attributes: {
                            // icon: 'money-check-alt' // Or whatever icon you want
                            icon: 'file' // Or whatever icon you want

                            }
                        }
                    },

                    {
                        href: '/PnadiSearch',
                        title: this.$t('menu.search'),
                        // icon: '/assets/images/only-logo.jpg'
                        // icon: 'user-secret'
                        icon: {
                            element: 'font-awesome-icon',
                            attributes: {
                            // icon: 'money-check-alt' // Or whatever icon you want
                            icon: 'search' // Or whatever icon you want

                            }
                        }
                    },


                    // {
                    //     href: '',
                    //     title: this.$t('footer.fitness'),
                    //     icon: {
                    //         element: 'font-awesome-icon',
                    //         attributes: {
                    //         icon: 'running' 


                    //         }
                    //     },

                    //     child: [
                    //         {
                    //             href: '/sessions',
                    //             title: this.$t('menu.sessions'),
                    //             icon: {
                    //                 element: 'font-awesome-icon',
                    //                 attributes: {
                    //                 icon: 'hourglass-half',


                    //                 }
                    //             },
                    //         },
                    //         {
                    //             href: '/clientSubscriptions',
                    //             title: this.$t('menu.memberships'),
                    //             icon: {
                    //                 element: 'font-awesome-icon',
                    //                 attributes: {
                    //                 icon: 'id-card',
                    //                 }
                    //             },
                    //         },
                    //     ]
                    // },

                    
                    // {
                    //     href: '/bookingPitches',
                    //     title: this.$t('menu.pitch'),
                    //     icon: {
                    //         element: 'font-awesome-icon',
                    //         attributes: {
                    //         icon: 'futbol' 
                    //         }
                    //     }
                    // },
                ];
        },

        onToggleCollapse(value){

            // this.menuOpen = !value;
            // console.log(`before onToggleCollapse ${this.objectsBag.isOpenMenu}`);

            this.objectsBag.isOpenMenu = !value;
            // console.log(`after onToggleCollapse ${this.objectsBag.isOpenMenu}`);
        },


        onItemClick(value){

            // console.log(`in onItemClick: ${JSON.stringify(value)}`);
        },

    },

    data: function(){

        return {

            menuOpen: false,
            isArabic: this.$i18n.locale == 'ar' ?  true: false,
            menu: new Array(), 
        }
    },

     watch: {

        'objectsBag':{
        
            handler(newValue) {
            
            this.menuOpen = newValue.isOpenMenu;
            // console.log(`in Watcher: objectsBag.isOpenMenu is ${newValue.isOpenMenu}`);
            //     require('tailwindcss-rtl')
            },
            deep: true
        },
        
         '$i18n.locale'(newValue) {

            
            // console.log(`before, this.menu: ${JSON.stringify(this.menu)}`);

            // this.menu = this.menu.filter(item=>item);
            this.setMenu();
            // console.log(`after, this.menu: ${JSON.stringify(this.menu)}`);

            this.isArabic =  this.$i18n.locale == 'ar';
            // this.menuOpen = newValue;
            // console.log(`in Watcher: i18n.locale is ${newValue}`);
            // /    require('tailwindcss-rtl'),

            },
            
    },
}
</script>

<style>

/*burger Menu*/
.bm-burger-button {
      position: fixed;
      width: 36px;
      left: 16px;
      top: 18px;
      cursor: pointer;
      background-color: #63B3ED;
    }
.bm-burger-bars {
    background-color: #D53F8C;
    border-radius: .5rem;

}
.line-style {
    position: absolute;
    height: 20%;
    top: 0;

    left: 0;
    right: 0;
}
.cross-style {
    position: absolute;
    top: 12px;
    right: 2px;
    cursor: pointer;
}
.bm-cross {
    background: #bdc3c7;
}
.bm-cross-button {
    height: 24px;
    width: 24px;
}
.bm-menu {
    height: 95%; /* 100% Full-height */
    width: 0; /* 0 width - change this with JavaScript */
    position: fixed; /* Stay in place */
    z-index: 1000; /* Stay on top */
    top: 2rem;
    
    left: 0;
    background-color: #ffff;
    /*background-color: rgb(63, 63, 65);  Black*/
    overflow-x: hidden; /* Disable horizontal scroll */
    padding-top: 60px; /* Place content 60px from the top */
    transition: 0.5s; /*0.5 second transition effect to slide in the sidenav*/
    border-top-right-radius:.5rem;
    border-bottom-right-radius:.5rem;
    border-right-color: #D53F8C;

    border: 2px solid white;
    border-top-color: #D53F8C;
    border-right-color: #D53F8C;

    border-bottom-color: #D53F8C;


}

.bm-overlay {
    background: rgba(0, 0, 0, 0.3);
}
.bm-item-list {
    color: #b8b7ad;
    margin-left: 10%;
    font-size: 20px;
}
.bm-item-list > * {
    display: flex;
    text-decoration: none;
    padding: 0.7em;
}
.bm-item-list > * > span {
    margin-left: 10px;
    font-weight: 700;
    color: #D53F8C;

}
</style>